import { Global, css } from '@emotion/react';
import { BaseStyles, useTheme } from '@doxyme/ui-foundation/theme';
import { ReactElement } from 'react';

type Props = {
  isInCall: boolean;
};

/**
 * Creates Dashboard / In-call aware custom scrollbar styles.
 * (Will appear dark in call, light in dashboard)
 */
export const ScrollbarStyles = ({ isInCall }: Props): ReactElement => {
  const theme = useTheme();

  return (
    <Global
      styles={css([
        BaseStyles,
        css`
          ::-webkit-scrollbar {
            width: 8px;
            height: 8px;
            border-radius: 30px;
          }
          ::-webkit-scrollbar-thumb {
            background: ${isInCall
              ? theme.palette.neutral.lightAlpha[450]
              : theme.scrollBar.background};
            border-radius: 15px;
            background-clip: content-box;
          }
          ::-webkit-scrollbar-track {
            background: transparent;
          }
          ::-webkit-scrollbar-button {
            display: none;
          }
        `,
      ])}
    />
  );
};
